import { RootState } from 'store';

export const selectors = {
  isDarkMode: (state: RootState) => state.settings.darkMode,
  showStreaks: (state: RootState) => state.settings.showStreaks,
  turnOnSoundsInApp: (state: RootState) => state.settings.turnOnSoundsInApp,
  inviteCourseId: (state: RootState) => state.settings.inviteCourseId,
  prevStreakCount: (state: RootState) => state.settings.prevStreakCount,
};
